import functions from "../../firebase/functions";
import { httpsCallable } from "firebase/functions";

const state = {
  products: null,
  remaining: null,
  valid: null,
  history: {
    affiliates: null,
    feedbacks: null,
    purchases: null,
  },
  lastAddress: null,
  affiliateAuthorized: null,
};

const getters = {
  getProducts(state) {
    return state.products;
  },
  getRemainingDays(state) {
    return state.remaining;
  },
  getPurchases(state) {
    return state.history.purchases;
  },
  getAffiliates(state) {
    return state.history.affiliates;
  },
  getFeedbackHistory(state) {
    return state.history.feedbacks;
  },
  getLastAddress(state) {
    return state.lastAddress;
  },
  getAffiliateAuthorized(state) {
    return state.affiliateAuthorized;
  },
};

const actions = {
  async getProductsFromFirebase({ commit }) {
    const getProducts = httpsCallable(functions, "membership-getProducts");
    return await getProducts({})
      .then((result) => {
        commit("SET_PRODUCTS", result.data);
        return true;
      })
      .catch((error) => {
        throw error;
      });
  },
  async getMembershipFromFirebase({ commit }) {
    const getMembership = httpsCallable(functions, "membership-get");
    await getMembership({})
      .then((result) => {
        commit("SET_MEMBERSHIP", result.data);
        return true;
      })
      .catch((error) => {
        console.log('error is ' + error)
        commit("SET_INIT_ERROR", error, { root: true });
      });
  },
  async revokePurchase({ commit, dispatch }, purchaseId) {
    const revokePurchase = httpsCallable(
      functions,
      "membership-revokePurchase"
    );
    await revokePurchase(purchaseId);
    commit("SET_APP_LOADED_STATE", false, { root: true });
    await dispatch("getMembershipFromFirebase");
    commit("SET_APP_LOADED_STATE", true, { root: true });
  },
};

const mutations = {
  SET_PRODUCTS(state, products) {
    state.products = products;
  },
  SET_MEMBERSHIP(state, payload) {
    if (payload) {
      state.remaining = payload.remaining;
      state.valid = payload.valid;
      state.history = payload.history;
      state.lastAddress = payload.lastAddress;
      state.affiliateAuthorized = payload.affiliateAuthorized;
    } else {
      state.remaining = null;
      state.valid = null;
      state.history = {
        affiliates: null,
        feedbacks: null,
        purchases: null,
      };
      state.lastAddress = null;
      state.affiliateAuthorized = null;
    }
  },
};

const membership = {
  namespaced: true,

  state,
  getters,
  actions,
  mutations,
};

export default membership;
